var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPassword = function SvgPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.58 27.16c7.5 0 13.58-6.08 13.58-13.58S21.08 0 13.58 0 0 6.08 0 13.58s6.08 13.58 13.58 13.58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.905 12.302V8.467c0-.958.8-1.757 1.758-1.757h3.674c.959 0 1.758.799 1.758 1.757v3.835h1.597V8.467c0-1.757-1.437-3.355-3.355-3.355h-3.674c-1.758 0-3.355 1.438-3.355 3.355v3.835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.852 11.663H8.148c-.32 0-.64.32-.64.639v8.947c0 .319.32.639.64.639h10.864c.32 0 .639-.32.639-.64v-8.946c-.16-.32-.48-.64-.799-.64m-4.793 4.952v1.918c0 .32-.32.479-.48.479h-.159q-.48 0-.48-.48v-1.917c-.319-.16-.638-.639-.638-.958 0-.64.48-1.278 1.278-1.278.639 0 1.278.479 1.278 1.278-.16.32-.32.799-.799.958"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27v27H0z"
  })))));
};
export default SvgPassword;